import { render } from "./DMSWarranty.vue?vue&type=template&id=6f3325ca"
import script from "./DMSWarranty.vue?vue&type=script&lang=js"
export * from "./DMSWarranty.vue?vue&type=script&lang=js"

import "./DMSWarranty.vue?vue&type=style&index=0&id=6f3325ca&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__